import { PawPrint } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "They treat my Bella like she's their own.",
    author: "Sarah M., Moose Jaw",
    variant: "side",
  },
  {
    quote:
      "Boarded our boy for two weeks. Came home happy, calm, and well-cared-for. Wouldn't take him anywhere else.",
    author: "Mike R., Caronport",
    variant: "feature",
  },
  {
    quote: "My cat actually enjoys going. That's a miracle.",
    author: "Jenna L., Moose Jaw",
    variant: "side",
  },
];

function Paws({ light }) {
  return (
    <div className="testimonial__paws" aria-hidden>
      {[0, 1, 2, 3, 4].map((i) => (
        <PawPrint
          key={i}
          className="w-3.5 h-3.5"
          strokeWidth={2}
          style={{ color: light ? "rgba(255,255,255,0.85)" : "var(--pp-gold)" }}
        />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="testimonials" data-testid="testimonials">
      <div className="testimonials__heading">
        <span className="overline" style={{ color: "var(--pp-gold)" }} >FROM OUR FAMILIES</span>
        <h2 className="section-h2">61 reviews. 100% recommend.</h2>
      </div>
      <div className="testimonials__grid">
        {TESTIMONIALS.map((t) => (
          <article
            key={t.author}
            className={`testimonial testimonial--${t.variant}`}
            data-testid={`testimonial-${t.author.split(",")[0].replace(/\s+/g, "-")}`}
          >
            <Paws light={t.variant === "feature"} />
            <blockquote className="testimonial__quote">{t.quote}</blockquote>
            <p className="testimonial__author">— {t.author}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
